import {
  Autocomplete,
  Box,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Switch,
  TextField,
  Typography,
  Link,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { PictureAsPdf, Visibility } from '@mui/icons-material';
import { withPaymentMethodFieldGroup } from './usePaymentMethodForm';
import { useAuth } from '../../../stores';
import CloudTerminalTroubbleshootingGuide from '../../../assets/cloudTerminalTroubleshootingGuide.pdf';

const suggestedResellers = ['Nets', 'Bambora', 'Elavon', 'Swedbank'];

const NetsFieldGroup = withPaymentMethodFieldGroup({
  defaultValues: {
    terminalId: '',
    username: '',
    password: '',
    boughtViaEnklakassan: false,
    acquirer: '',
    acquirerNumber: '',
    mccCode: '',
  },
  props: {},
  render: function Render({ group }) {
    const { t } = useTranslation();
    const auth = useAuth();
    const [showPassword, setShowPassword] = useState(false);
    return (
      <>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom sx={{ mt: 2, mb: 2 }}>
            Nets inställningar
          </Typography>
        </Grid>
        <group.Field name="terminalId">
          {(field) => (
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label={t('paymethodScreen.terminalId')}
                value={field.state.value}
                onChange={(e) => field.handleChange(e.target.value)}
                error={field.state.meta.errors.length > 0}
                helperText={field.state.meta.errors.join(', ')}
              />
            </Grid>
          )}
        </group.Field>

        <group.Field name="username">
          {(field) => (
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label={t('paymethodScreen.username')}
                value={field.state.value}
                onChange={(e) => field.handleChange(e.target.value)}
                error={field.state.meta.errors.length > 0}
                helperText={field.state.meta.errors.join(', ')}
              />
            </Grid>
          )}
        </group.Field>

        <group.Field name="password">
          {(field) => (
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label={t('paymethodScreen.password')}
                value={field.state.value}
                onChange={(e) => field.handleChange(e.target.value)}
                error={field.state.meta.errors.length > 0}
                helperText={field.state.meta.errors.join(', ')}
                type={showPassword ? 'text' : 'password'}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          setShowPassword(!showPassword);
                        }}
                      >
                        <Visibility />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          )}
        </group.Field>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom sx={{ mt: 2, mb: 2 }}>
            Information om terminalen
          </Typography>
        </Grid>

        <group.Field name="acquirer">
          {(field) => (
            <Grid item xs={12} md={6}>
              <Autocomplete
                freeSolo
                options={suggestedResellers}
                value={field.state.value}
                onChange={(_, newValue) => field.handleChange(newValue || '')}
                renderInput={(params) => (
                  <TextField
                    required
                    label="Inlösare"
                    fullWidth
                    error={field.state.meta.errors.length > 0}
                    helperText={
                      field.state.meta.errors.join(', ') ||
                      'Välj från listan eller skriv in en egen'
                    }
                    inputRef={params.InputProps.ref}
                    inputProps={params.inputProps}
                  />
                )}
              />
            </Grid>
          )}
        </group.Field>

        <group.Field name="acquirerNumber">
          {(field) => (
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label="Inlösarens nummer"
                value={field.state.value}
                onChange={(e) => field.handleChange(e.target.value)}
              />
            </Grid>
          )}
        </group.Field>

        <group.Field name="mccCode">
          {(field) => (
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label="MCC-kod"
                value={field.state.value}
                onChange={(e) => field.handleChange(e.target.value)}
              />
            </Grid>
          )}
        </group.Field>

        {auth.isAdmin && (
          <group.Field name="boughtViaEnklakassan">
            {(field) => (
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={field.state.value}
                      onChange={(e) => field.handleChange(e.target.checked)}
                      color="secondary"
                    />
                  }
                  label="Köpt via Enklakassan"
                />
                <Typography variant="body2" color="text.secondary" sx={{ ml: 4 }}>
                  Markera om terminalen är köpt genom Enklakassan
                </Typography>
              </Grid>
            )}
          </group.Field>
        )}

        <Grid item xs={12}>
          <Box display="flex" alignItems="center">
            <PictureAsPdf sx={{ mr: 1 }} />
            <Link
              href={CloudTerminalTroubbleshootingGuide}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              color="#000"
            >
              {t('paymethodScreen.netsCloudTroubleshooting')}
            </Link>
          </Box>
        </Grid>
      </>
    );
  },
});

export default NetsFieldGroup;
